import { render, staticRenderFns } from "./pending-separation-filters.vue?vue&type=template&id=c64a56ac&scoped=true"
import script from "./pending-separation-filters.vue?vue&type=script&lang=js"
export * from "./pending-separation-filters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c64a56ac",
  null
  
)

export default component.exports